import {regReducer} from '../../core';
import * as a from './actions';
import * as r from 'ramda';

regReducer(a.SHOW_LOCATION_BLOCKED, (state, {payload}) => {
    return r.assocPath(['findMe', payload, 'showLocationBlocked'], true, state);
});

regReducer(a.HIDE_LOCATION_BLOCKED, (state, {payload}) => {
    return r.dissocPath(['findMe', payload, 'showLocationBlocked'], state);
});
